import { useState } from 'preact/hooks'

export const useCacheConfig = () => {
  const [cacheConfig, setCacheConfig] = useState({})

  /**
   *
   * @param {'ProfileConnections'} key
   * @param {any} value
   */
  const handleSetCacheConfig = (key, value) => {
    setCacheConfig((c) => ({
      ...c,
      [key]: value
    }))
  }

  return {
    cacheConfig,
    handleSetCacheConfig
  }
}
